import api from './index'
import { axios } from '@/utils/request'

export function getHospitalList (parameter) {
  return axios({
    url: api.HospitalList,
    method: 'get',
    params: parameter
  })
}

export function addHospital (projectId, hospital) {
  return axios({
    url: api.AddHospital,
    method: 'post',
    params: {
      item_id: projectId,
      source_name: hospital
    }
  })
}

export function editHospital (hospitalId, hospital) {
  return axios({
    url: api.EditHospital,
    method: 'put',
    params: {
      source_id: hospitalId,
      source_name: hospital
    }
  })
}

export function deleteHospital (source_id) {
  return axios({
    url: api.DeleteHospital + '/' + source_id,
    method: 'delete'
  })
}
